// extracted by mini-css-extract-plugin
module.exports = {"navigation":"Layout-module--navigation--18KyX","logo":"Layout-module--logo--2rNz8"};